export default __webpack_public_path__ + "static/media/storiesmb.c2b910fc.svg";